<div [class.disabled]="disabled">
	<svg fill="none" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
		<rect fill="#009DD6" height="32" rx="4" width="32" />
		<g clip-path="url(#clip0)">
			<path d="M18.759 15.4779L16.6234 19.749C16.5652 19.8653 16.4752 19.9627 16.3639 20.0299C16.2525 20.0971 
					16.1244 20.1313 15.9944 20.1286C15.8644 20.1259 15.7378 20.0864 15.6293 20.0147C15.5209 19.9429 15.435 
					19.8419 15.3816 19.7233L12.9367 14.2963L11.6477 17.3772H7.6043L15.4461 25.3908C15.5175 25.4652 15.6033 
					25.5244 15.6982 25.5648C15.793 25.6052 15.8951 25.626 15.9982 25.626C16.1014 25.626 16.2034 25.6052 
					16.2983 25.5648C16.3932 25.5244 16.4789 25.4652 16.5504 25.3908L24.3969 17.3772H19.7086L18.759 15.4779ZM25.3547 
					8.1797L25.2516 8.07227C24.7273 7.53575 24.1011 7.10943 23.4097 6.81836C22.7183 6.52729 21.9758 6.37736 21.2256 
					6.37736C20.4755 6.37736 19.7329 6.52729 19.0415 6.81836C18.3501 7.10943 17.7239 7.53575 17.1997 8.07227L16 
					9.29903L14.8011 8.07442C14.2774 7.53693 13.6513 7.10975 12.9598 6.81807C12.2683 6.5264 11.5254 6.37613 
					10.775 6.37613C10.0245 6.37613 9.2816 6.5264 8.59012 6.81807C7.89863 7.10975 7.27255 7.53693 6.74879 
					8.07442L6.6461 8.1797C4.55352 10.3195 4.46329 13.727 6.33243 16.0043H10.7329L12.275 12.3004C12.3264 
					12.1761 12.4131 12.0697 12.5243 11.9942C12.6356 11.9187 12.7665 11.8775 12.901 11.8757C13.0354 
					11.8738 13.1675 11.9115 13.2807 11.9839C13.394 12.0563 13.4835 12.1604 13.5383 12.2832L16.0395 
					17.8391L18.145 13.6324C18.2022 13.5186 18.2899 13.4229 18.3984 13.356C18.5069 13.2892 18.6318 
					13.2537 18.7592 13.2537C18.8866 13.2537 19.0115 13.2892 19.12 13.356C19.2285 13.4229 19.3162 
					13.5186 19.3734 13.6324L20.5594 16.0043H25.6679C27.5375 13.7248 27.4477 10.3174 25.3547 8.1797Z" fill="white" />

			<path d="M24.379 17.375L24.3747 17.3771H19.7087L18.7591 15.4779L16.6235 19.749C16.5653 19.8653 16.4753 
					19.9627 16.364 20.0299C16.2526 20.0971 16.1245 20.1313 15.9945 20.1286C15.8645 20.1259 15.7379 
					20.0864 15.6294 20.0146C15.5209 19.9429 15.4351 19.8418 15.3817 19.7232L12.9368 14.2963L11.6477 
					17.3771H7.62114V17.375L6.33423 16.0021H10.7329L12.2751 12.2982C12.3265 12.174 12.4131 12.0675 
					12.5244 11.992C12.6357 11.9165 12.7666 11.8753 12.9011 11.8735C13.0355 11.8717 13.1675 11.9093 
					13.2808 11.9817C13.3941 12.0542 13.4836 12.1582 13.5384 12.281L16.0396 17.8369L18.1451 13.6303C18.2023 
					13.5164 18.29 13.4207 18.3985 13.3539C18.507 13.287 18.6319 13.2516 18.7593 13.2516C18.8867 13.2516 
					19.0116 13.287 19.1201 13.3539C19.2285 13.4207 19.3163 13.5164 19.3735 13.6303L20.5595 16.0021H25.668L24.379 17.375Z" fill="#009DD6" />
		</g>
		<defs>
			<clipPath id="clip0">
				<rect fill="white" height="22" transform="translate(5 5)" width="22" />
			</clipPath>
		</defs>
	</svg>
</div>
